import React, { Component } from 'react';
import axios from 'axios'
import { Link } from 'react-router-dom';
import { Row, Col, Radio, Card } from 'antd';
import 'antd/dist/antd.css';
import '../App.css'
import moment from 'moment';
import { connect } from 'react-redux';

const API_HOST_URL = process.env.REACT_APP_API_URL

class TripsBooked extends Component {

  state = {
    selectedButton: 'Upcoming',
    bookings: []
  }

  componentDidMount() {
    this.upcomingBookings();
  }

  upcomingBookings = () => {
    axios.get(`${API_HOST_URL}/api/bookings/upcoming_passenger_bookings/?user_id=${this.props.loggedInUser.pk}&expand=trip`)
      .then(res => {
        this.setState({
          bookings: res.data
        })
      })
  }

  pastBookings = () => {
    axios.get(`${API_HOST_URL}/api/bookings/past_passenger_bookings/?user_id=${this.props.loggedInUser.pk}&expand=trip`)
      .then(res => {
        this.setState({
          bookings: res.data
        })
      })
  }

  handleChange = e => {
    console.log("button clicked: ", e.target.value)
    this.setState({
      selectedButton: e.target.value
    })
    if (e.target.value == 'Upcoming') {
      this.upcomingBookings()
    } else if (e.target.value == 'Past') {
      this.pastBookings()
    }

  }

  render() {

    const { bookings, selectedButton } = this.state

    return (
      <div>
        <div style={{ paddingTop: '30px' }}>
          <Row>
            <Col md={{ span: 18, offset: 3 }}>
              <h2>Trips I Booked</h2>
              <Radio.Group value={selectedButton} size="large" onChange={this.handleChange} >
                <Radio.Button value="Upcoming" style={selectedButton == 'Upcoming' ? { backgroundColor: '#0099ff' } : {}}>
                  <h4 style={selectedButton == 'Upcoming' ? { color: '#ffffff' } : {}}>Upcoming</h4>
                </Radio.Button>
                <Radio.Button value="Past" style={selectedButton == 'Past' ? { backgroundColor: '#0099ff' } : {}}>
                  <h4 style={selectedButton == 'Past' ? { color: '#ffffff' } : {}}>Past</h4>
                </Radio.Button>
              </Radio.Group>
            </Col>
          </Row>
        </div>
        <div style={{ paddingTop: '24px' }}>
          {
            bookings.length > 0 ?
              bookings.map(booking => (
                <Row>
                  <Col md={{ span: 18, offset: 3 }}>
                    <Card>
                      <Row>
                        <Col md={{ span: 12 }}>
                          <h4 style={{ fontWeight: "bold", color: '#0099ff' }}>
                            <Link to={`/trip-detail/${booking.trip.id}`}> {booking.trip.originCity} to {booking.trip.destinationCity}</Link>
                          </h4>
                          <h4 style={{ fontWeight: "normal" }} className="GrayText">{moment(booking.trip.departureDate).format('dddd, D MMMM YYYY')} at {moment(booking.trip.departureTime, "hh:mm").format("hh:mm A")}</h4>
                          {/* <Divider /> */}
                          {/* <Button type="primary">Edit</Button>&nbsp; */}
                          {/* <Button type="primary" style={{ backgroundColor: '#ff3d00', borderWidth: '0px' }}>Cancel Booking</Button> */}
                        </Col>
                        <Col md={{ span: 11, offset: 1 }}>
                          {/* <h4 style={{fontWeight: "normal", fontStyle: "italic"}} className="GrayText">No bookings on this trip</h4> */}
                          {/* <h4 style={{fontWeight: "bold", color: '#0099ff'}}>
                                    <Link to="/trip-detail"> 2 Requests</Link><br/>
                                </h4>*/}
                          <h4 style={{ fontWeight: "bolder", color: ( booking.bookingStatus == "approved") ? "green" : (booking.bookingStatus == "rejected" ? "red": "#0099ff") }}>
                            {booking.bookingStatus != 'requested' ? 'Driver ' + booking.bookingStatus + ' your request' : 'Waiting for driver to confirm'}
                          </h4>
                        </Col>
                      </Row>

                    </Card>
                  </Col>
                </Row>
              ))
              :
              <div>
                <Row>
                  <Col md={{ span: 18, offset: 3 }}>
                    <h4>You don't have any {selectedButton} trips.</h4>
                  </Col>
                </Row>
              </div>
          }

        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.token !== null,
    loggedInUser: state.currentUser,
    token: state.token
  }
}

export default connect(mapStateToProps, null)(TripsBooked);
